export function getFinancialAdvisoryResponse(inputValue: string) {
	return getTotalfinancialValue(inputValue);
}

function getTotalfinancialValue(inputStringValue: string): number {
	const inputValue = removeFormatting(inputStringValue);

	if (inputValue >= 600000 && inputValue <= 1000000) {
		return inputValue * 7;
	} else if (inputValue >= 1000001 && inputValue <= 1400000) {
		return inputValue * 9;
	} else if (inputValue >= 1400001 && inputValue <= 2500000) {
		return inputValue * 12;
	} else {
		return inputValue * 14;
	}
}

function removeFormatting(inputValue: string): number {
	const inputSinFormato = inputValue.replace('.', '');
	return Number.parseInt(inputSinFormato);
}
